import { render } from "./NewsList.vue?vue&type=template&id=5f2f4b8c"
import script from "./NewsList.vue?vue&type=script&lang=ts"
export * from "./NewsList.vue?vue&type=script&lang=ts"
script.render = render

export default script